import axios from "axios";
import { useMutation, UseMutationResult } from "@tanstack/react-query";
import { useConsoleAuthStore } from "store/useConsoleAuthStore";
import { enum_api_uri } from "../utils/enum";

interface LoginRequest {
    a_id: string;
    a_pwd: string;
}

interface LoginResponse {
    data: {
        accessToken: string;
        a_id: string;
        a_name: string;
    };
}

export const usePostLogin = (successCallback?: () => void): UseMutationResult<LoginResponse, Error, LoginRequest, unknown> => {
    const setAuth = useConsoleAuthStore(state => state.setAuth);

    return useMutation<LoginResponse, Error, LoginRequest>({
        mutationFn: async ({ a_id, a_pwd }: LoginRequest) => {
            const response = await axios.post(enum_api_uri.console_login, {
                a_id,
                a_pwd,
            });
            return response.data;
        },
        onSuccess: data => {
            const info = data.data;

            setAuth({
                accessToken: info.accessToken,
                a_id: info.a_id,
                a_name: info.a_name,
            });

            successCallback?.();
        },
        // onError: error => {
        //     alert(error.message);
        // },
    });
};
